module.exports = __webpack_public_path__ + "static/media/exit-black.eb11eae0.svg";